<template lang="pug">
    div

        div.pull-right
            ul.nav.pull-right
                li.nav-item.inline.dropdown
                    a(data-toggle="dropdown", class="nav-link btn btn-default") Export
                    div.dropdown-menu.dropdown-menu-scale.pull-right
                        span.dropdown-header Export As
                        a(class="dropdown-item", v-on:click.prevent="exportAsFile('CSV')") CSV
                        a(class="dropdown-item", v-on:click.prevent="exportAsFile('PDF')") PDF

            div.w-lg.m-r-sm.pull-right
                datepicker(
                    @onChange="applyDateFilter",
                    class-name="pull-right w-lg",
                    :auto-init-date="false",
                    :allow-empty="true",
                    :use-vuex="false"
                )

            div.w-md.m-r-sm.pull-right
                input(
                    type="search",
                    class="form-control",
                    placeholder="Search...",
                    @keyup="$refs.datatable.serverSearch($event)"
                )

        h5._300.margin.m-t-md Claim History

        div.box
            v-server-table(
                :url="api",
                :name="tableName" ref="datatable",
                :columns="columns",
                :options="options"
            )
              div(slot="action" slot-scope="props")
                  button.btn.btn-icon.btn-sm.info(
                      data-toggle="tooltip"
                      title="Copy"
                      @click="copyColumn(props.row)"
                  )
                      i.fa.fa-copy

        div(class="modal fade" id="receipt-modal" data-backdrop="false")
            div.right.w-xxl.white.b-l
                vuepopup_receipt(:transaction="transaction")
</template>

<script>
import Auth from '@js/plugins/auth';

export default {
    data() {
        var vm = this;

        return {
            transaction: null,
            tableName: 'VUETABLE_COUPON_INVOICE',
            columns: [
                'paid_at',
                'name',
                'customer_name',
                'customer_phone',
                'url_redeem',
                'action',
            ],
            options: {
                filterable: false,
                templates: {
                    bill_id(h_, row, index) {
                        return require('./bill_id.jsx')(h_, row);
                    },
                    paid_at(h_, row, index) {
                        return moment(row.paid_at).format(
                            'DD/MM/YYYY hh:mm:ss A',
                        );
                    },
                    url_redeem(h, row) {
                        return (
                            window.location.origin +
                            '/redeem/' +
                            Auth.franchise().slug +
                            '/' +
                            row.slug
                        );
                    },
                },
                rowClassCallback: row => 'pointer',
                headings: {
                    paid_at: 'Claim Date',
                    name: 'Voucher',
                    customer_name: 'Name',
                    customer_phone: 'Phone',
                    url_redeem: 'Link Redemption',
                    action: 'Action',
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.inventory.voucher-redeem.invoices');
        },

        tableParams() {
            let params = Object.assign(
                {},
                { query: this.$refs.datatable.query },
                this.$refs.datatable.customQueries,
            );

            return params;
        },
    },

    methods: {
        copyColumn(data) {
            let stringUrl =
                window.location.origin +
                '/redeem/' +
                Auth.franchise().slug +
                '/' +
                data.slug;
            navigator.clipboard.writeText(stringUrl);
            this.showSwalSuccess(stringUrl + ' successfully copied');
        },
        exportAsFile(type) {
            let url = Laroute.route(
                'franchise.inventory.voucher-redeem.exportInvoice',
                { type: type },
            );
            window.location.href = url + '?' + $.param(this.tableParams);
        },

        applyDateFilter(payload) {
            let start = payload.start;
            let end = payload.end;

            this.$refs.datatable.customQueries.since = start;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'until',
                value: end,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/couponredeem/coupon-invoices.vue